<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="0">
        <v-icon left>mdi-book</v-icon>
        <v-toolbar-title>System Configuration - Registered At</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'system-configuration-registered-at-toolbar',
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>